import { createContext } from "react";

export type TurnstileContextType = {
  token: string | null;
  isReady: boolean;
  isScriptLoaded: boolean;
  resetTurnstile: () => void;
  setToken: (token: string | null) => void;
  setWidgetId: (widgetId: string | null) => void;
  /**
   * The token to send with a request, read at call time rather than from the
   * render that created the caller. A missing or expired token resets the
   * widget and waits for the next one; `null` once `TURNSTILE_TOKEN_TIMEOUT_MS`
   * passes without one.
   */
  getFreshToken: () => Promise<string | null>;
};

export const TurnstileContext = createContext<TurnstileContextType | null>(
  null,
);
